import { ImportedEmployee, TerminatedEmployeeInput } from '../types';
import { createEmptyEmployee } from '../utils/createEmptyEmployee';
import { normalizeSocialSecurityNumber } from '../utils/socialSecurityNumber';

export const mapImportedEmployee = (
  imported: ImportedEmployee
): TerminatedEmployeeInput => ({
  ...createEmptyEmployee(),
  socialSecurityNumber: normalizeSocialSecurityNumber(
    imported.socialSecurityNumber
  ),
  firstName: imported.firstName?.trim() ?? '',
  lastName: imported.lastName?.trim() ?? '',
  employmentType:
    imported.employmentType === null || imported.employmentType === undefined
      ? ''
      : String(imported.employmentType),
  startDate: imported.startDate ?? '',
  terminationDate: imported.terminationDate ?? '',
  endDate: imported.endDate ?? '',
  email: imported.email?.trim() ?? '',
  phone: imported.phone?.trim() ?? '',
});
